module.exports = __webpack_public_path__ + "assets/17d83bd59d04314545524f6ef5ffee62.svg";